module.exports = __webpack_public_path__ + "public/SiteIcons/shareEmail.svg?b45a5519";